// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message__box {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  text-align: center;
  font-size: 0;
}
.message {
  display: flex;
  margin-top: 20px;
  background: #fff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 0 16px;
  overflow: hidden;
  text-align: left;
  height: 32px;
  box-sizing: border-box;
  animation: msg-move-down 0.3s ease-in-out forwards;
  align-items: center;
}
.message__icon {
  float: left;
  position: relative;
  top: 1px;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background-size: 100% auto;
}
.message__content {
  font-size: 14px;
}
.message--success {
  background: #e8fff4;
  box-sizing: border-box;
  border: 1px solid #30bf75;
}
.message--success .message__icon {
  background: url("https://p4.ssl.qhimg.com/t01749d7b173a4ed233.png") no-repeat;
  background-size: cover;
}
.message--success .message__content {
  color: #30BF75;
}
.message--error {
  opacity: 1;
  background: #fff7e5;
  box-sizing: border-box;
  border: 1px solid rgba(255, 98, 0, 0.3);
}
.message--error .message__icon {
  background: url("https://p2.ssl.qhimg.com/t0165cc0cbff0da5d93.png") no-repeat;
  background-size: cover;
}
.message--error .message__content {
  color: #ff6200;
}
.message--info .message__icon {
  background-position: 0 0;
}
.message--warning .message__icon {
  background-position: 0 -48px;
}
.message--hide {
  animation: msg-move-up 0.3s ease-in-out forwards;
}
@keyframes msg-move-down {
  from {
    transform: translateY(-150%);
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes msg-move-up {
  from {
    opacity: 1;
  }
  to {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Message/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AACF;AAEA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kDAAA;EACA,mBAAA;AAAF;AAEE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EAEA,0BAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAME;EACE,mBAAA;EAEA,sBAAA;EACA,yBAAA;AALJ;AACE;EAOI,6EAAA;EAEE,sBAAA;AANR;AAHE;EAYM,cAAA;AANR;AAWE;EACE,UAAA;EAEA,mBAAA;EAEA,sBAAA;EACA,uCAAA;AAXJ;AAKE;EASI,6EAAA;EAEA,sBAAA;AAZN;AACE;EAcM,cAAA;AAZR;AAgBE;EAEI,wBAAA;AAfN;AAmBE;EAEI,4BAAA;AAlBN;AAsBE;EACE,gDAAA;AApBJ;AAwBA;EACE;IACE,4BAAA;IACA,UAAA;EAtBF;EAyBA;IACE,UAAA;EAvBF;AACF;AA0BA;EACE;IACE,UAAA;EAxBF;EA2BA;IACE,SAAA;IACA,cAAA;IACA,iBAAA;IACA,SAAA;IACA,UAAA;EAzBF;AACF","sourcesContent":[".message__box {\n  z-index: 10;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  text-align: center;\n  font-size: 0;\n}\n\n.message {\n  display: flex;\n  margin-top: 20px;\n  background: #fff;\n  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 0 16px;\n  overflow: hidden;\n  text-align: left;\n  height: 32px;\n  box-sizing: border-box;\n  animation: msg-move-down 0.3s ease-in-out forwards;\n  align-items: center;\n\n  &__icon {\n    float: left;\n    position: relative;\n    top: 1px;\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n    // background: url(\"~@/assets/message_icon.png\") no-repeat;\n    background-size: 100% auto;\n  }\n\n  &__content {\n    font-size: 14px;\n    \n  }\n\n  &--success {\n    background: #e8fff4;\n\n    box-sizing: border-box;\n    border: 1px solid #30bf75;\n\n    .message__icon {\n      background: url(\"https://p4.ssl.qhimg.com/t01749d7b173a4ed233.png\")\n        no-repeat;\n        background-size: cover;\n    }\n    .message__content {\n        color: #30BF75;\n\n    }\n  }\n\n  &--error {\n    opacity: 1;\n\n    background: #fff7e5;\n\n    box-sizing: border-box;\n    border: 1px solid rgba(255, 98, 0, 0.3);\n\n    .message__icon {\n      background: url(\"https://p2.ssl.qhimg.com/t0165cc0cbff0da5d93.png\")\n        no-repeat;\n      background-size: cover;\n    }\n    .message__content {\n        color: #ff6200;\n    }\n  }\n\n  &--info {\n    .message__icon {\n      background-position: 0 0;\n    }\n  }\n\n  &--warning {\n    .message__icon {\n      background-position: 0 -48px;\n    }\n  }\n\n  &--hide {\n    animation: msg-move-up 0.3s ease-in-out forwards;\n  }\n}\n\n@keyframes msg-move-down {\n  from {\n    transform: translateY(-150%);\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes msg-move-up {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin: 0;\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
